import {
  RequestContinentByName,
  RequestContinents,
  RequestOutReviewsByCountry,
} from "../dtos/exchanges/out";
import Server from "./index";

export default class ExchangesServer extends Server {
  constructor() {
    super("/exchanges_out.php");
  }

  public get(
    params:
      | RequestContinents
      | RequestContinentByName
      | RequestOutReviewsByCountry
  ): Promise<any> {
    return super.get(params);
  }
}
